import { useState, useEffect } from 'react';
import { Grid, Button, Box, useTheme } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Navigate from '@shared/components/Navigate/navigate';
import AlertTime from '@shared/components/AlertTime';
import useWindowSize from '@shared/hooks/useWindowsSize';

const GenericBookingLayout = ({
  steps = [],
  stepsWrapperComponent = null,
  formComponent = null,
  detailsComponent = null,
  storageKey = '',
  pago = false,
  expireTime = 900000,
  searchPath,
  operationType = 'compra',
}) => {
  const theme = useTheme();
  const screenSize = useWindowSize();
  const [scrollY, setScrollY] = useState(window.scrollY);

  const handleScrollTo = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  if (storageKey) {
    const existing = localStorage.getItem(storageKey);
    if (!existing) {
      localStorage.setItem(storageKey, Date.now());
    }
  }

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <AlertTime
        pago={pago}
        operationType={operationType}
        expireTime={expireTime}
        searchPath={searchPath}
        storageKey={storageKey}
      />

      <Box className="minWebPadding" sx={{ backgroundColor: '#F6F6F6' }}>
        <Grid
          id="layout-grid-container"
          container
          rowSpacing={{ xs: '14px', lg: 2 }}
          columnSpacing={{ xs: 2, lg: 4 }}
          sx={{
            width: '100%',
            mt: '0 !important',
            pb: { xs: 2, lg: '18px' },
          }}
        >
          {/* Botón "scroll to top" */}
          {screenSize.width < 1280 && scrollY > 1000 && (
            <Grid
              id="scroll-to-top-button-wrapper"
              sx={{
                display: 'flex',
                position: 'fixed',
                right: '1px',
                bottom: '1px',
                zIndex: 1000,
                justifyContent: 'flex-end',
              }}
            >
              <Button
                id="scroll-to-top-button"
                variant="contained"
                sx={{
                  mr: '5px',
                  mb: '5px',
                  height: '60px',
                  border: '1px solid #E5E5E5',
                  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
                  borderRadius: '100px',
                  bgcolor: theme.tertiary,
                  fontWeight: 600,
                  fontSize: '16px',
                  color: '#FFFFFF',
                }}
                onClick={handleScrollTo}
              >
                <ExpandLessIcon />
              </Button>
            </Grid>
          )}

          {/* Pasos / navegación */}
          <Grid item xs={12} id="layout-steps">
            {steps?.length > 0 && <Navigate steps={steps} />}
          </Grid>

          {/* Contenido principal */}
          <Grid
            item
            xs={12}
            lg={9}
            id="layout-main-content"
            sx={{ display: 'flex', flexDirection: 'column' }}
          >
            {stepsWrapperComponent}

            {/* Sidebar móvil */}
            <Grid
              item
              xs={12}
              id="layout-sidebar-mobile"
              sx={{ display: { xs: 'block', lg: 'none' }, pb: 1 }}
            >
              {detailsComponent}
            </Grid>

            {formComponent && (
              <Box
                id="layout-form-wrapper"
                sx={{ display: 'flex', flexDirection: 'column' }}
              >
                {formComponent}
              </Box>
            )}
          </Grid>

          {/* Sidebar desktop */}
          <Grid
            item
            xs={12}
            lg={3}
            id="layout-sidebar-desktop"
            sx={{ display: { xs: 'none', lg: 'block' } }}
          >
            {detailsComponent}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default GenericBookingLayout;
